<template>
  <div class="card-container">
    <div class="card-header">
      <span class="card-title">{{title}}</span>
      <span>
        <slot name="header-right"></slot>
      </span>
    </div>
    <div class="card-body">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<style lang="less" scoped>
.card-container {
  background: #fff;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;

    .card-title {
      font-size: 1rem;
      font-weight: 700;
    }
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
  methods: {},
};
</script>
